/**
 * 全局APP入口文件
 * 
 */
import { routerRedux } from 'dva/router'
export default {
  namespace: 'app',
  state: {
    user: {},
    permissions: []
  },
  reducer: {

  },
  effects: {
    *login({ payload }, { put, call }) { }
  },
  subscriptions: {
    setup({ history, dispatch }) {
    }
  }
}
